import React from 'react';

interface Props {
  text: string;
}

const ImpactBadge: React.FC<Props> = ({ text }) =>
  text !== 'N/A' ? (
    <div className={`circle-base ${text && text.replace('.', '')}`}>
      <div className="circle-inner">{text}</div>
    </div>
  ) : (
    text
  );

export default ImpactBadge;
